import * as T from '../types'

const House: T.ISvgFC = ({
  fill = '#000000',
  width = '16',
  height = '16',
  viewBox = '0 0 16 16',
}) => (
  <svg
    viewBox={viewBox}
    width={width}
    height={height}
  >
    <g
      strokeWidth="1"
      fill={fill}
      stroke={fill}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M8.995,7.005 L8.995,7.005c1.374,1.374,1.374,3.601,0,4.975l-1.99,1.99c-1.374,1.374-3.601,1.374-4.975,0l0,0c-1.374-1.374-1.374-3.601,0-4.975 l1.748-1.698"
      />
      <path
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M7.005,8.995 L7.005,8.995c-1.374-1.374-1.374-3.601,0-4.975l1.99-1.99c1.374-1.374,3.601-1.374,4.975,0l0,0c1.374,1.374,1.374,3.601,0,4.975 l-1.748,1.698"
      />
    </g>
  </svg>
)

export default House
